import styled from 'styled-components';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';

interface PageHeaderWrapperProps extends StyledComponentsPropWithTheme {
  isMobileDevice: boolean;
}

export const PageHeaderWrapper = styled.div<PageHeaderWrapperProps>`
  position: relative !important;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  margin: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
`;

export const RodeoContainer = styled.div`
  display: none;
`;
